import { END_POINTS } from "../constants/urls";
import { User } from "../types/User";
import emptySplitApi from "../utils/rtk";

interface CommonResponse {
  statusCode: number;
  message?: string;
  data?: any;
}

export const DashboardApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getPointsDashboardData: builder.query<
      CommonResponse & { data: any },
      { type: string }
    >({
      query: ({ type }) => {
        return {
          url: `${END_POINTS.pointsDashboardAll}`,
          method: "GET",
        };
      },
    }),
    getNotificationsDashboardData: builder.query<
      CommonResponse & { data: any },
      { type: string; startDate?: string; endDate?: string }
    >({
      query: ({ type, startDate, endDate }) => {
        let url = `${END_POINTS.notificationsDashboard}?type=${type}`;
        if (startDate && endDate && type === "custom") {
          url += `&startDate=${startDate}&endDate=${endDate}`;
        }
        return {
          url: url,
          method: "GET",
        };
      },
    }),
    getPointsActivity: builder.query<
      CommonResponse & { data: any },
      { type: string; startDate?: string; endDate?: string }
    >({
      query: ({ type, startDate, endDate }) => {
        let url = `${END_POINTS.pointsActivity}?type=${type}`;
        if (startDate && endDate && type === "custom") {
          url += `&startDate=${startDate}&endDate=${endDate}`;
        }
        return {
          url: url,
          method: "GET",
        };
      },
    }),
    getNotificationsSentVsOpened: builder.query<
      CommonResponse & { data: any },
      { type: string; startDate?: string; endDate?: string }
    >({
      query: ({ type, startDate, endDate }) => {
        let url = `${END_POINTS.notificationsSentVsOpened}?type=${type}`;
        if (startDate && endDate && type === "custom") {
          url += `&customStartDate=${startDate}&customEndDate=${endDate}`;
        }
        return {
          url: url,
          method: "GET",
        };
      },
    }),
    getTopCustomers: builder.query<
      CommonResponse & { data: any },
      { type: string; startDate?: string; endDate?: string }
    >({
      query: ({ type, startDate, endDate }) => {
        let url = `${END_POINTS.topCustomers}?type=${type}`;
        if (startDate && endDate && type === "custom") {
          url += `&startDate=${startDate}&endDate=${endDate}`;
        }
        return {
          url: url,
          method: "GET",
        };
      },
    }),
    getSessionsActivity: builder.query<
      CommonResponse & { data: any },
      { type: string; startDate?: string; endDate?: string }
    >({
      query: ({ type, startDate, endDate }) => {
        let url = `${END_POINTS.sessionsActivity}?type=${type}`;
        if (startDate && endDate && type === "custom") {
          url += `&startDate=${startDate}&endDate=${endDate}`;
        }
        return {
          url: url,
          method: "GET",
        };
      },
    }),
    getDailyUsageReports: builder.query<
      CommonResponse & { data: any },
      { type: string; startDate?: string; endDate?: string }
    >({
      query: ({ type, startDate, endDate }) => {
        let url = `${END_POINTS.dailyUsageReports}?type=${type}`;
        if (startDate && endDate && type === "custom") {
          url += `&startDate=${startDate}&endDate=${endDate}`;
        }
        return {
          url: url,
          method: "GET",
        };
      },
    }),
    getTransactionsDashboard: builder.query<
      CommonResponse & { data: any },
      { type: string; startDate?: string; endDate?: string }
    >({
      query: ({ type, startDate, endDate }) => {
        let url = `${END_POINTS.transactionsDashboard}?type=${type}`;
        if (startDate && endDate && type === "custom") {
          url += `&startDate=${startDate}&endDate=${endDate}`;
        }
        return {
          url: url,
          method: "GET",
        };
      },
    }),

    getUpcomingBirthdayList: builder.query<
      CommonResponse & { data: any },
      { type: string }
    >({
      query: ({ type }) => {
        return {
          url: `${END_POINTS.upcomingBirthdayList}`,
          method: "GET",
        };
      },
    }),
    getBirthdayNotificationsList: builder.query<
      CommonResponse & { data: any },
      {
        type: string;
        startDate?: string;
        endDate?: string;
        page?: number;
        limit?: number;
      }
    >({
      query: ({ type, startDate, endDate, page, limit }) => {
        let url = `${END_POINTS.birthdayNotificationsList}?type=${type}`;
        if (startDate && endDate && type === "custom") {
          url += `&startDate=${startDate}&endDate=${endDate}`;
        }
        if (page && limit) {
          url += `&page=${page}&limit=${limit}`;
        }
        return {
          url: url,
          method: "GET",
        };
      },
    }),
  }),
});
export const {
  useLazyGetPointsDashboardDataQuery,
  useLazyGetNotificationsDashboardDataQuery,
  useLazyGetPointsActivityQuery,
  useLazyGetNotificationsSentVsOpenedQuery,
  useLazyGetTopCustomersQuery,
  useLazyGetSessionsActivityQuery,
  useLazyGetDailyUsageReportsQuery,
  useLazyGetTransactionsDashboardQuery,
  useLazyGetUpcomingBirthdayListQuery,
  useLazyGetBirthdayNotificationsListQuery,
} = DashboardApi;
